// src/data/servicesData.js
import physioImg from "../assets/images/services/physio.jpg";
import osteopathyImg from "../assets/images/services/Osteopathy.jpg";
import acupunctureImg from "../assets/images/services/acupuncture.jpg";
import craniosacralImg from "../assets/images/services/Craniosacral.jpg";
import matrixImg from "../assets/images/services/matrix.jpg";
import chiroImg from "../assets/images/services/Chiropractic.jpg";
import postureImg from "../assets/images/services/posture.jpg";
import neuroImg from "../assets/images/services/neuro.jpg";
import kineticImg from "../assets/images/services/kinetic.jpg";
import somaticsImg from "../assets/images/services/ClinicalSomatics.jpg";
import consciousnessImg from "../assets/images/services/AccessConsciousnessPractices.jpg";
import pelvicImg from "../assets/images/services/pelvic.jpg";

export const servicesData = [
  {
    id: "physiotherapy",
    img: physioImg,
    title: "Physiotherapy & Sports Rehab",
    excerpt:
      "Comprehensive physiotherapy & sports rehab for injury recovery, mobility restoration, and enhanced performance.",
    // short intro paragraph(s)
    content:
      "At BrightLife Physio Point, our Physiotherapy & Sports Rehabilitation program helps individuals of all ages restore mobility, relieve pain, and return to an active lifestyle with confidence. Whether you're recovering from an injury, dealing with chronic pain, or preparing to return to sports, our expert physiotherapists design customized, evidence-based treatment plans tailored to your goals.",
    // supporting paragraph
    content2:
      "We combine hands-on manual therapy with progressive exercise therapy, motor-control retraining and sport-specific conditioning. Our clinicians use modern assessment tools and treatment techniques to ensure safe, measurable progress and a guided return to activity.",
    // short bulleted lists to render as features/quick facts
    features: [
      "Personalized one-on-one treatment sessions",
      "Evidence-based manual therapy and exercise programs",
      "Sports-specific rehabilitation and return-to-play protocols",
      "Post-operative and fracture rehabilitation",
      "Injury prevention and performance enhancement",
      "Modern electrotherapy and recovery modalities",
    ],
    // conditions we treat - good for rendering chips or lists
    conditions: [
      "Sports injuries (strains, sprains, ACL/MCL, rotator cuff)",
      "Back & Neck Pain, Disc-related pain, Sciatica",
      "Knee pain & osteoarthritis",
      "Shoulder pain & frozen shoulder",
      "Post-surgical rehabilitation (joint replacements, ACL)",
      "Postural dysfunction and workplace strain",
      "Chronic pain and movement disorders",
    ],
    // treatment methods - map to UI cards or icons
    treatments: [
      "Manual therapy (joint mobilization, soft tissue release)",
      "Therapeutic exercise & strength training",
      "Motor control & gait retraining",
      "Balance & proprioception training",
      "Electrotherapy (TENS, IFT, Ultrasound)",
      "Functional movement screening & sport drills",
      "Injury prevention programs & education",
    ],
    // expanded content paragraph
    content3:
      "Our rehab process begins with a detailed assessment — we identify the root cause, set measurable goals, and co-design a plan that fits your lifestyle. Sessions focus on hands-on treatment combined with active rehabilitation so you regain strength, flexibility and confidence to return to your everyday life or sport.",
    // FAQ array for rendering accordions
    faq: [
      {
        q: "How many sessions will I need?",
        a: "The number of sessions depends on the condition and your goals. Many patients notice improvement in 3–5 sessions, while complex or post-surgical cases may require a longer program. We provide progress reviews and adjust the plan as you improve.",
      },
      {
        q: "Do I need a doctor's referral?",
        a: "No referral is required — you can book a physiotherapy assessment directly with us. If you have recent imaging or surgical notes, please bring them along for a faster, accurate assessment.",
      },
      {
        q: "Will physiotherapy stop my pain permanently?",
        a: "We focus on both symptom relief and addressing underlying causes. While not all chronic pain can be completely eliminated, most patients gain significant long-term improvements in function, pain levels, and quality of life.",
      },
      {
        q: "Do you offer sports-specific rehab?",
        a: "Yes — we create return-to-play programs tailored to the athlete’s sport, position and competition level, including strength, conditioning and movement retraining.",
      },
    ],
    // call-to-action details - useful for service page CTA buttons/sections
    cta: {
      headline: "Ready to get back to what you love?",
      text: "Book a detailed assessment today and start your personalised recovery plan.",
      buttonText: "Book Appointment",
      // you can use an internal route or phone link depending on your app
      link: "/book-appointment",
      phone: "+91-XXXXXXXXXX",
    },
    // optional meta for SEO or page rendering
    meta: {
      pageTitle: "Physiotherapy & Sports Rehab | BrightLife Physio Point",
      metaDescription:
        "Physiotherapy and sports rehabilitation in Kondapur. Personalized rehab for sports injuries, back pain, post-surgery recovery and performance enhancement.",
      keywords: [
        "physiotherapy hyderabad",
        "sports rehab kondapur",
        "back pain treatment",
        "post surgical rehab",
      ],
    },
  },

 {
  id: "osteopathy",
  img: osteopathyImg,
  title: "Osteopathy",
  excerpt:
    "Hands-on osteopathic treatment to restore balance, mobility, and natural healing.",
  content:
    "Our Osteopathy services focus on treating the body as a whole rather than isolated symptoms. Using gentle hands-on techniques, we improve joint mobility, muscle function, circulation, and nervous system balance.",
  content2:
    "Osteopathy is effective for both acute and chronic conditions and is suitable for people of all ages. Treatment aims to restore alignment, reduce strain, and support the body’s natural healing mechanisms.",
  features: [
    "Whole-body assessment and treatment",
    "Gentle hands-on manual techniques",
    "Improves posture and joint mobility",
    "Reduces chronic pain and stiffness",
    "Supports nervous system function",
  ],
  conditions: [
    "Back and neck pain",
    "Postural imbalances",
    "Joint stiffness and arthritis",
    "Headaches and migraines",
    "Repetitive strain injuries",
  ],
  treatments: [
    "Soft tissue release",
    "Joint mobilization",
    "Myofascial techniques",
    "Postural correction advice",
  ],
  content3:
    "Each session begins with a detailed assessment to understand your movement patterns and lifestyle. Treatment is tailored to address the root cause of discomfort and improve long-term function.",
  faq: [
    {
      q: "Is osteopathy painful?",
      a: "Osteopathy is generally gentle and well tolerated. Techniques are adapted to your comfort level.",
    },
    {
      q: "Who can benefit from osteopathy?",
      a: "Osteopathy is suitable for adults, elderly patients, and individuals with chronic pain or mobility restrictions.",
    },
  ],
  cta: {
    headline: "Restore balance and movement",
    text: "Book an osteopathy assessment and experience whole-body care.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
    phone: "+91-XXXXXXXXXX",
  },
  meta: {
    pageTitle: "Osteopathy Treatment | BrightLife Physio Point",
    metaDescription:
      "Osteopathy treatment in Hyderabad for back pain, posture correction and joint mobility.",
    keywords: ["osteopathy hyderabad", "manual therapy", "joint mobility"],
  },
},

 {
  id: "acupuncture",
  img: acupunctureImg,
  title: "Acupuncture & Dry Needling",
  excerpt:
    "Targeted needling techniques to reduce pain and muscle tension.",
  content:
    "Acupuncture and Dry Needling are effective techniques used to relieve pain, release tight muscles, and improve circulation. These methods target trigger points and neural pathways to restore normal muscle function.",
  content2:
    "This therapy is commonly combined with physiotherapy and manual therapy for faster and longer-lasting results.",
  features: [
    "Trigger point pain relief",
    "Reduces muscle spasms",
    "Improves circulation",
    "Accelerates healing",
  ],
  conditions: [
    "Neck and shoulder pain",
    "Low back pain",
    "Sports injuries",
    "Headaches and migraines",
    "Chronic muscle tightness",
  ],
  treatments: [
    "Dry needling",
    "Traditional acupuncture",
    "Myofascial trigger point release",
  ],
  content3:
    "Our therapists carefully assess your condition before treatment to ensure safety and optimal results.",
  faq: [
    {
      q: "Is dry needling safe?",
      a: "Yes, when performed by trained professionals, it is safe and effective.",
    },
    {
      q: "Does it hurt?",
      a: "You may feel a brief twitch or mild soreness which usually settles quickly.",
    },
  ],
  cta: {
    headline: "Release pain and muscle tension",
    text: "Experience targeted pain relief with needling therapy.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
    phone: "+91-XXXXXXXXXX",
  },
  meta: {
    pageTitle: "Acupuncture & Dry Needling | BrightLife Physio Point",
    metaDescription:
      "Dry needling and acupuncture therapy for pain relief and muscle recovery.",
    keywords: ["dry needling", "acupuncture therapy", "pain relief"],
  },
},

 {
  id: "craniosacral",
  img: craniosacralImg,
  title: "Craniosacral Therapy",
  excerpt:
    "Gentle therapy supporting nervous system regulation and relaxation.",
  content:
    "Craniosacral Therapy is a subtle hands-on approach that works with the body’s craniosacral system to release deep tension and improve nervous system balance.",
  content2:
    "It is especially beneficial for stress-related conditions, headaches, and nervous system dysregulation.",
  features: [
    "Extremely gentle and non-invasive",
    "Reduces stress and tension",
    "Improves sleep quality",
    "Supports nervous system health",
  ],
  conditions: [
    "Headaches and migraines",
    "Stress and anxiety",
    "TMJ dysfunction",
    "Post-concussion symptoms",
  ],
  treatments: [
    "Craniosacral release techniques",
    "Nervous system regulation",
  ],
  content3:
    "This therapy promotes deep relaxation and allows the body to self-correct and heal naturally.",
  faq: [
    {
      q: "Is craniosacral therapy safe?",
      a: "Yes, it is one of the gentlest therapies and suitable for all ages.",
    },
  ],
  cta: {
    headline: "Experience deep relaxation",
    text: "Support your nervous system with gentle therapy.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
    phone: "+91-XXXXXXXXXX",
  },
  meta: {
    pageTitle: "Craniosacral Therapy | BrightLife Physio Point",
    metaDescription:
      "Craniosacral therapy for stress, headaches and nervous system balance.",
    keywords: ["craniosacral therapy", "nervous system regulation"],
  },
},

  {
  id: "matrix",
  img: matrixImg,
  title: "Matrix Rhythm Therapy",
  excerpt:
    "Advanced rhythmic therapy to improve muscle recovery and circulation.",
  content:
    "Matrix Rhythm Therapy uses rhythmic mechanical vibrations to restore healthy muscle movement and improve cellular metabolism.",
  content2:
    "It is highly effective for chronic pain, muscle stiffness, and post-injury recovery.",
  features: [
    "Improves circulation",
    "Enhances muscle flexibility",
    "Reduces chronic pain",
    "Non-invasive therapy",
  ],
  conditions: [
    "Muscle stiffness",
    "Chronic pain",
    "Sports injuries",
    "Post-surgical recovery",
  ],
  treatments: [
    "Rhythmic vibration therapy",
    "Muscle relaxation techniques",
  ],
  content3:
    "This therapy helps muscles regain their natural rhythm and coordination.",
  faq: [
    {
      q: "Is this therapy painful?",
      a: "No, it is comfortable and relaxing for most patients.",
    },
  ],
  cta: {
    headline: "Boost recovery and mobility",
    text: "Experience advanced muscle recovery therapy.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
    phone: "+91-XXXXXXXXXX",
  },
  meta: {
    pageTitle: "Matrix Rhythm Therapy | BrightLife Physio Point",
    metaDescription:
      "Matrix rhythm therapy for muscle recovery and pain relief.",
    keywords: ["matrix rhythm therapy", "muscle recovery"],
  },
},

  {
  id: "chiropractic",
  img: chiroImg,
  title: "Manual / Chiropractic Therapy",
  excerpt:
    "Hands-on spinal and joint therapy for alignment and pain relief.",
  content:
    "Manual and Chiropractic Therapy focuses on restoring joint alignment and improving spinal mobility to relieve pain and improve posture.",
  content2:
    "Treatments are personalized and performed safely using evidence-based techniques.",
  features: [
    "Relieves back and neck pain",
    "Improves spinal alignment",
    "Enhances joint mobility",
  ],
  conditions: [
    "Neck and back pain",
    "Joint dysfunction",
    "Postural issues",
  ],
  treatments: [
    "Joint mobilization",
    "Spinal manipulation",
    "Soft tissue techniques",
  ],
  content3:
    "Our approach aims to restore natural movement patterns and long-term relief.",
  faq: [
    {
      q: "Is chiropractic therapy safe?",
      a: "Yes, when performed by trained professionals after proper assessment.",
    },
  ],
  cta: {
    headline: "Move better, live pain-free",
    text: "Restore alignment and mobility with expert care.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
    phone: "+91-XXXXXXXXXX",
  },
  meta: {
    pageTitle: "Manual & Chiropractic Therapy | BrightLife Physio Point",
    metaDescription:
      "Chiropractic and manual therapy for spine and joint pain.",
    keywords: ["chiropractic therapy", "manual therapy"],
  },
},
  {
  id: "nkt",
  img: neuroImg,
  title: "Neuro Kinetic Therapy (NKT)",
  excerpt:
    "Identify and correct faulty movement patterns at their neurological root.",
  content:
    "Neuro Kinetic Therapy identifies dysfunctional movement patterns caused by poor muscle coordination and neurological compensation.",
  content2:
    "By testing and correcting muscle activation, NKT helps retrain the body to move efficiently and reduces the likelihood of recurring injuries.",
  features: [
    "Identifies movement dysfunction",
    "Improves muscle coordination",
    "Reduces injury recurrence",
  ],
  conditions: [
    "Recurrent injuries",
    "Chronic pain without clear cause",
    "Movement compensation patterns",
  ],
  treatments: [
    "Manual muscle testing",
    "Corrective movement strategies",
    "Neuromuscular re-education",
  ],
  content3:
    "NKT focuses on the root cause rather than treating symptoms alone.",
  faq: [
    {
      q: "Is NKT painful?",
      a: "No, NKT is a gentle assessment and correction-based therapy.",
    },
  ],
  cta: {
    headline: "Fix the Root Cause of Pain",
    text: "Retrain your body for efficient movement.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
  },
  meta: {
    pageTitle: "Neuro Kinetic Therapy (NKT) | BrightLife Physio Point",
    metaDescription:
      "Neuro Kinetic Therapy for correcting faulty movement patterns and chronic pain.",
    keywords: ["neuro kinetic therapy", "movement correction", "NKT therapy"],
  },
},

  {
  id: "kinetic",
  img: kineticImg,
  title: "Kinetic Control Therapy",
  excerpt:
    "Motor control retraining to improve stability and functional movement.",
  content:
    "Kinetic Control Therapy focuses on retraining precise movement control to restore stability and reduce pain caused by poor motor control.",
  content2:
    "The therapy progresses from simple corrective exercises to functional movements relevant to daily activities and sports.",
  features: [
    "Improves movement control",
    "Enhances joint stability",
    "Reduces movement-related pain",
  ],
  conditions: [
    "Joint instability",
    "Movement-related pain",
    "Poor motor control",
  ],
  treatments: [
    "Movement assessment",
    "Corrective exercise programs",
    "Functional retraining",
  ],
  content3:
    "The goal is long-term movement confidence and injury prevention.",
  faq: [
    {
      q: "Is this suitable for athletes?",
      a: "Yes, it is highly effective for athletes and active individuals.",
    },
  ],
  cta: {
    headline: "Move with Control & Confidence",
    text: "Build strength, stability, and precision.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
  },
  meta: {
    pageTitle: "Kinetic Control Therapy | BrightLife Physio Point",
    metaDescription:
      "Motor control therapy for stability, posture, and pain reduction.",
    keywords: ["kinetic control", "motor control therapy", "movement retraining"],
  },
},

 {
  id: "somatics",
  img: somaticsImg,
  title: "Clinical Somatics",
  excerpt:
    "Nervous-system based movement to reduce chronic muscle tension.",
  content:
    "Clinical Somatics uses gentle, awareness-based movements to reset muscle tension patterns controlled by the nervous system.",
  content2:
    "This approach is especially effective for chronic pain, stiffness, and stress-related muscular holding patterns.",
  features: [
    "Reduces chronic muscle tension",
    "Improves body awareness",
    "Supports nervous system balance",
  ],
  conditions: [
    "Chronic stiffness",
    "Stress-related pain",
    "Long-standing muscular tension",
  ],
  treatments: [
    "Guided somatic movements",
    "Neuromuscular relaxation",
    "Self-care movement education",
  ],
  content3:
    "Clinical Somatics empowers individuals to maintain relief through awareness and movement.",
  faq: [
    {
      q: "Is this suitable for older adults?",
      a: "Yes, it is gentle and safe for all age groups.",
    },
  ],
  cta: {
    headline: "Release Chronic Tension",
    text: "Reconnect with ease and comfort in movement.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
  },
  meta: {
    pageTitle: "Clinical Somatics Therapy | BrightLife Physio Point",
    metaDescription:
      "Gentle nervous-system based therapy for chronic tension and stiffness.",
    keywords: ["clinical somatics", "chronic pain relief", "somatic therapy"],
  },
},

 {
  id: "consciousness",
  img: consciousnessImg,
  title: "Access Consciousness Practices",
  excerpt:
    "Holistic practices supporting relaxation, clarity, and wellbeing.",
  content:
    "Access Consciousness practices are gentle, non-invasive techniques designed to reduce stress and promote deep relaxation.",
  content2:
    "These sessions complement physical therapies by supporting mental clarity, emotional balance, and overall wellbeing.",
  features: [
    "Promotes relaxation",
    "Reduces stress",
    "Enhances overall wellbeing",
  ],
  conditions: [
    "Stress and anxiety",
    "Mental fatigue",
    "Emotional tension",
  ],
  treatments: [
    "Individual sessions",
    "Guided relaxation techniques",
    "Mind-body awareness practices",
  ],
  content3:
    "This approach supports healing by addressing the mind-body connection.",
  faq: [
    {
      q: "Is this a replacement for physiotherapy?",
      a: "No, it complements physical treatments and enhances overall outcomes.",
    },
  ],
  cta: {
    headline: "Relax. Reset. Renew.",
    text: "Support your wellbeing beyond physical care.",
    buttonText: "Book Session",
    link: "/book-appointment",
  },
  meta: {
    pageTitle: "Access Consciousness Practices | BrightLife Physio Point",
    metaDescription:
      "Holistic wellbeing practices for stress relief and relaxation.",
    keywords: ["access consciousness", "holistic therapy", "stress relief"],
  },
},

 {
  id: "pelvic",
  img: pelvicImg,
  title: "Pelvic Floor Rehabilitation",
  excerpt:
    "Targeted pelvic rehabilitation to restore strength and confidence.",
  content:
    "Pelvic Floor Rehabilitation focuses on restoring strength, coordination, and function of the pelvic muscles through assessment-led programs.",
  content2:
    "Treatment plans are personalized and particularly beneficial for postpartum recovery and pelvic dysfunction.",
  features: [
    "Improves pelvic strength",
    "Supports postpartum recovery",
    "Enhances core stability",
  ],
  conditions: [
    "Pelvic floor dysfunction",
    "Postpartum recovery",
    "Core weakness",
  ],
  treatments: [
    "Pelvic floor assessment",
    "Targeted strengthening exercises",
    "Core stability training",
  ],
  content3:
    "Our goal is to restore confidence, comfort, and daily function.",
  faq: [
    {
      q: "Is pelvic rehab only for women?",
      a: "No, pelvic floor therapy benefits both men and women.",
    },
  ],
  cta: {
    headline: "Restore Strength & Confidence",
    text: "Personalized pelvic health care you can trust.",
    buttonText: "Book Appointment",
    link: "/book-appointment",
  },
  meta: {
    pageTitle: "Pelvic Floor Rehabilitation | BrightLife Physio Point",
    metaDescription:
      "Pelvic floor physiotherapy for strength, recovery, and core stability.",
    keywords: ["pelvic floor therapy", "postpartum rehab", "core stability"],
  },
},

];
